import React, { Component } from 'react'

import BlueskyFeed from "./BlueskyFeed";


export default class Bluesky extends Component {
    render () {
        return (
            <div className="container">
            <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css"></link>
              <div className="bluesky-embed">
              <h3><i className="fa fa-link fa-lg cyan color"></i> Bluesky <span><a href="https://bsky.app/profile/ariaaccess.bsky.social" target="_blank" rel="noopener noreferrer" className="blueskyName">@ariaaccess.bsky.social</a></span></h3>
                  
                  <BlueskyFeed handle="ariaaccess.bsky.social" limit={5} />
              </div>
            </div>
            
          );
    }
}